import { backendRequest } from '../../shared/vasiBackend';

/**
 * The cloud 5L report flow talks only to vasi-backend; vasi-admin makes no
 * Firestore reads or writes for it. The report itself
 * (cloud_eval_reports/{evaluationId}) is generated by vasi_functions on
 * upload; the admin only edits it.
 */

const reportPath = (evaluationId) => `/admin/cloud-reports/${encodeURIComponent(evaluationId)}`;

/** The report plus `publishedTemplate: {id, version, keys}`, or null if not generated. */
export async function loadCloudReport(evaluationId, options = {}) {
  if (!evaluationId) return null;
  try {
    return await backendRequest(reportPath(evaluationId), options);
  } catch (error) {
    if (error.status === 404) return null;
    throw error;
  }
}

/**
 * PATCH a partial edit. `baseEditedAt` is the editedAt the editor loaded;
 * the backend answers 409 if someone saved in between. Returns the updated
 * report (same shape as GET).
 */
export function saveCloudReportEdits({ evaluationId, changes, baseEditedAt = null, ...options } = {}) {
  if (!evaluationId) return Promise.reject(new Error('Cannot save a report without an evaluation id.'));
  return backendRequest(reportPath(evaluationId), {
    ...options,
    method: 'PATCH',
    body: { ...changes, baseEditedAt },
  });
}

export const backendCloudReportApi = {
  loadReport: (evaluationId) => loadCloudReport(evaluationId),
  saveReport: (args) => saveCloudReportEdits(args),
};

const templatePath = (sex) => `/admin/templates/${encodeURIComponent(sex)}`;

/**
 * Shared interpretation template library for template owners. Same method
 * names CloudTemplateCms used with the old Firestore api.
 */
export const backendTemplateApi = {
  loadTemplatesForSex: (sex) => backendRequest(templatePath(sex)),
  saveDraft: ({ sex, keys }) => backendRequest(`${templatePath(sex)}/draft`, { method: 'PUT', body: { keys: keys ?? {} } }),
  publishDraft: ({ sex }) => backendRequest(`${templatePath(sex)}/publish`, { method: 'POST' }),
};
